<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_cu9" :refresh="{ query: RefreshList }">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :footer-method="footerMethod"
      show-footer
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          field="invoiceTitle"
          title="发票抬头"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceTitle"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="taxRegistrationNumber"
          title="税务登记证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.taxRegistrationNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="invoiceNumber"
          title="发票号码"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceAmount"
          title="开票总金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.invoiceAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.invoiceAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceStatus"
          title="发票状态"
          :formatter="formatterInvoiceStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.invoiceStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in invoiceStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receiverName"
          title="申请人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="receiverPhone"
          title="托运人电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiverPhone"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column>
        <vxe-table-column
          field="invoiceRemark"
          title="开票备注"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceRemark"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="申请时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceIssuedTime"
          title="发票开具时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.invoiceIssuedTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'invoiceIssuedTime')"
          />
        </template>
      </vxe-table-column>
      <!-- 有效标志 -->
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-if="modelDetailFlag"
      v-model="modelDetailFlag"
      title="发票详情"
      width="1200"
      height="600"
      resize
    >
      <compDetail
        :sigleInfo="sigleInfo"
        ref="DetailRef"
        :belongs-to="'list'"
        @hideModel="hideModel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelMakeOutFlag"
      title="开具发票"
      width="1000"
      height="800"
      resize
    >
      <compMakeOut ref="MakeOutRef" @hideModel="hideModel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compDetail from "./components/invoiceDetail.vue";
import compMakeOut from "./components/invoiceMakeOut.vue";
import {
  listByHB,
  repeatInvoice,
  fastRed,
  queryRed,
  confirmRed
} from "@/api/invoice";
export default {
  name: "InvoiceList",
  components: {
    compDetail,
    compMakeOut
  },
  data() {
    return {
      // 机构列表
      branchList: this.$store.state.components.branchList,
      exportObj: {
        exportUrl: "/ntocc-basic-api/invoice/exportInvoiceManageList", //导出接口
        name: "发票列表"
      },
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      modelMakeOutFlag: false,
      partyType: this.$store.getters.party.partyType,
      listQuery: {
        gmtCreatedRange: "",
        invoiceIssuedTimeRange: "",
        invoiceStatus: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 状态
      invoiceStatusList: [
        { label: "申请开票", value: 0 },
        { label: "已开票", value: 1 },
        { label: "已取消", value: 2 },
        { label: "确认收票", value: 3 },
        { label: "开票中", value: 4 },
        { label: "开票失败", value: 5 },
        { label: "红冲中", value: 6 },
        { label: "已红冲", value: 7 },
        { label: "红冲待确认", value: 8 }
      ],
      authStatusList: [
        { label: "审核中", value: "0" },
        { label: "已通过", value: "1" },
        { label: "已驳回", value: "2" }
      ],
      sumObject: {},
      //当前登录机构code
      branchCode: this.$store.state.user.party.branchCode,
      sigleInfo: {}
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.invoiceStatus = 0;
      } else {
        this.listQuery.invoiceStatus = "";
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.invoiceStatus = 0;
    }
    this.findList();
  },
  methods: {
    async goConfirmRed(code) {
      this.$confirm("是否确认财务红冲？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          let res = await confirmRed({});
          if (res.status === 0) {
            this.$message.success("确认成功");
            this.findList();
          }
        } catch (err) {}
      });
    },
    redReversal(code) {
      this.$confirm("是否冲红该发票？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await fastRed({ code });
        if (res.status === 0) {
          this.$message.success("已发起红冲，等待确认");
          this.findList();
        }
        console.log("开票结果=======", res);
      });
    },
    async resetCode(code) {
      this.$confirm("是否重新开票？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let res = await repeatInvoice({ code });
        if (res.status === 0) {
          this.$message.success("重新开票成功");
        }
        console.log("开票结果=======", res);
      });
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        listByHB(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 翻译状态
    formatterInvoiceStatus({ cellValue }) {
      const item = this.invoiceStatusList.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 展示弹框
    showModel(code, prefix, info) {
      this.sigleInfo = info;
      this[`model${prefix}Flag`] = true;
      this.$nextTick(() => {
        if (info.invoiceType === "2") {
          this.$refs[`${prefix}Ref`].getRedInfo(code);
        } else {
          this.$refs[`${prefix}Ref`].getInfo(code);
        }
      });
    },
    // 隐藏弹框
    hideModel() {
      this.modelDetailFlag = false;
      this.modelMakeOutFlag = false;
      this.findList();
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "invoiceAmount") {
            if (this.sumObject) {
              return this.$XEUtils.sum(data, column.property);
            } else {
              return 0;
            }
          }
          return "-";
        })
      ];
    }
  }
};
</script>
<style scoped>
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}
::v-deep .vxe-table--footer-wrapper.body--wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
</style>
